import React from "react";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
import Dialog from "../../Services/Common/Dialog";
import IndexedDb from "../../Services/IndexedDb/IndexedDb";
/** Components Import */
import Mm10040View from "../../Views/Manufacture/MM10040";
import Snackbar from "../../Components/Snackbar";
import { now } from "moment/moment";

function MM10040(props) {
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [lanData, setLanData] = React.useState([]);
  const [rowData, setRowData] = React.useState([
    {
      processCd1: "",
      processCd2: "",
      processCd3: "",
      processCd4: "",
    },
  ]);
  const [columnDefs, setColumnDefs] = React.useState([]);
  const [autoGroupColumnDef, setAutoGroupColumnDef] = React.useState([]);
  const [rowData1, setRowData1] = React.useState([]);
  const [procData, setProcData] = React.useState([]);
  const [changedRowData, setChangedRowData] = React.useState([]);
  const [changedRowData1, setChangedRowData1] = React.useState([]);
  const [selectedRowData, setSelectedRowData] = React.useState([]);
  const [selectedRowData1, setSelectedRowData1] = React.useState([]);
  const [selectedRadio, setSelectedRadio] = React.useState("0");
  const [nowDate, setNowDate] = React.useState(new Date());
  const today = new Date();
  const monthAgo = new Date(today);
  const [startDate, setStartDate] = React.useState(
    monthAgo.setMonth(today.getMonth() - 3)
  );
  let selectedPoNo = "";
  const [endDate, setEndDate] = React.useState(new Date());
  let getLanData = [];

  React.useEffect(() => {
    window.addEventListener("error", (e) => {
      if (
        e.message === "ResizeObserver loop limit exceeded" ||
        e.message ===
          "ResizeObserver loop completed with undelivered notifications."
      ) {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client- overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
    const GetLanData = async () => {
      try {
        await IndexedDb.GetAllDb("LanguageList").then((result) => {
          if (result.length > 0) {
            getLanData = result.filter((f) => f.lanType !== "MENU");
          }
          setLanData(getLanData);
        });
      } catch (e) {
      } finally {
        getProcData();
      }
    };
    GetLanData();
  }, [selectedRadio]);

  const getProcData = async () => {
    let getProcData = [];
    try {
      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Manufacture.MM10040.GetProcInfo
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: data,
          });
        } else if (data.type === "Error") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: "데이터가 없습니다.",
          });
        } else {
          getProcData.push(
            {
              field: "woNo",
              headerName:
                getLanData.length > 0
                  ? getLanData.filter(
                      (f) => f.lanId === "Col_WoNo" && f.lanType === "COL"
                    )[0].lanName
                  : "", //작업지시번호
              minWidth: 130,
            },
            {
              field: "itemCd",
              headerName:
                getLanData.length > 0
                  ? getLanData.filter(
                      (f) => f.lanId === "Col_ItemCd" && f.lanType === "COL"
                    )[0].lanName
                  : "", //품목코드
            },
            {
              field: "stusNm",
              headerName:
                getLanData.length > 0
                  ? getLanData.filter(
                      (f) => f.lanId === "Col_StatusName" && f.lanType === "COL"
                    )[0].lanName
                  : "", //상태값
              cellRenderer: Commons.CustomHeaderRenderer,
            },
            {
              field: "itemNm",
              headerName:
                getLanData.length > 0
                  ? getLanData.filter(
                      (f) => f.lanId === "Col_ItemNm" && f.lanType === "COL"
                    )[0].lanName
                  : "", //품목명
              minWidth: 200,
              pinned: "left",
            },
            {
              field: "itemStd",
              headerName:
                getLanData.length > 0
                  ? getLanData.filter(
                      (f) => f.lanId === "Col_ItemStd1" && f.lanType === "COL"
                    )[0].lanName
                  : "", //규격
              // cellStyle: { textAlign: "left" },
            },
            {
              field: "plantNm",
              headerName:
                getLanData.length > 0
                  ? getLanData.filter(
                      (f) => f.lanId === "Col_PlantCd" && f.lanType === "COL"
                    )[0].lanName
                  : "", //사업장
              minWidth: 100,
              cellRenderer: Commons.CustomPlantRenderer,
            },
            {
              field: "custNm",
              headerName:
                getLanData.length > 0
                  ? getLanData.filter(
                      (f) => f.lanId === "Col_CustNm" && f.lanType === "COL"
                    )[0].lanName
                  : "", //거래처
              rowGroup: selectedRadio == "1" ? true : false,
              hide: selectedRadio == "1" ? true : false,
            },
            {
              field: "whNm",
              headerName:
                getLanData.length > 0
                  ? getLanData.filter(
                      (f) => f.lanId === "Col_WhNm" && f.lanType === "COL"
                    )[0].lanName
                  : "", //창고
              minWidth: 130,
              cellRenderer: Commons.CustomWhCdRenderer,
            },
            {
              field: "itemQty",
              headerName:
                getLanData.length > 0
                  ? getLanData.filter(
                      (f) => f.lanId === "Col_OrderQty" && f.lanType === "COL"
                    )[0].lanName
                  : "", //주문수량
              cellStyle: { textAlign: "right" },
              valueFormatter: (params) => {
                var formatted = params.value
                  ? params.value
                      .toString()
                      .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
                  : "";
                return formatted;
              },
              aggFunc: "sum",
            },
            {
              field: "delivQty",
              headerName:
                getLanData.length > 0
                  ? getLanData.filter(
                      (f) =>
                        f.lanId === "Col_ShipmentQuantity" &&
                        f.lanType === "COL"
                    )[0].lanName
                  : "", //출하수량
              cellStyle: { textAlign: "right" },
              valueFormatter: (params) => {
                var formatted = params.value
                  ? params.value
                      .toString()
                      .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
                  : "";
                return formatted;
              },
              aggFunc: "sum",
              minWidth: 100,
            },
            {
              field: "quanQty",
              headerName:
                getLanData.length > 0
                  ? getLanData.filter(
                      (f) => f.lanId === "Col_LossQty" && f.lanType === "COL"
                    )[0].lanName
                  : "", //남은수량
              cellStyle: { textAlign: "right" },
              valueFormatter: (params) => {
                var formatted = params.value
                  ? params.value
                      .toString()
                      .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
                  : "";
                return formatted;
              },
              aggFunc: "sum",
            },
            {
              field: "soDt",
              headerName:
                getLanData.length > 0
                  ? getLanData.filter(
                      (f) => f.lanId === "Col_SoDate" && f.lanType === "COL"
                    )[0].lanName
                  : "", //주문일자
              // cellStyle: { textAlign: "right" },
              // valueFormatter: (params) => {
              //   var formatted = params.value
              //     ? params.value
              //       .toString()
              //       .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
              //     : "";
              //   return formatted;
              // },
              // aggFunc: "sum",
            },
            {
              field: "soDueDt",
              headerName:
                getLanData.length > 0
                  ? getLanData.filter(
                      (f) => f.lanId === "Col_DliveDate" && f.lanType === "COL"
                    )[0].lanName
                  : "", //납기일자
              // cellStyle: { textAlign: "right" },
              // valueFormatter: (params) => {
              //   var formatted = params.value
              //     ? params.value
              //         .toString()
              //         .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
              //     : "";
              //   return formatted;
              // },
              // aggFunc: "sum",
            }
          );
          for (let i = 0; i < data.length; i++) {
            let workQty =
              "workQty" + Number(data[i].processCd.substring(3, 6)).toString();

            let seqQty =
              "seqQty" + Number(data[i].processCd.substring(3, 6)).toString();
            let wkStDt =
              "wkStDt" + Number(data[i].processCd.substring(3, 6)).toString();
            let wkEdDt =
              "wkEdDt" + Number(data[i].processCd.substring(3, 6)).toString();
            let processTime =
              "processTime" +
              Number(data[i].processCd.substring(3, 6)).toString();
            if (
              data[i].processNm == "주문" ||
              data[i].processNm == "교정승인단계" ||
              data[i].processNm == "출하"
            ) {
            } else {
              getProcData.push({
                // headerName: props.rowData[0] ? props.rowData[0].processCd1 : "공정1",
                headerName: data[i].processNm,
                children: [
                  {
                    field: workQty,
                    headerName:
                      getLanData.length > 0
                        ? getLanData.filter(
                            (f) =>
                              f.lanId === "Col_WorkQty" && f.lanType === "COL"
                          )[0].lanName
                        : "", //지시수량
                    cellStyle: { textAlign: "right" },
                    aggFunc: "sum",
                    minWidth: 100,
                  },
                  {
                    field: seqQty,
                    headerName:
                      getLanData.length > 0
                        ? getLanData.filter(
                            (f) =>
                              f.lanId === "Col_SeqQty" && f.lanType === "COL"
                          )[0].lanName
                        : "", //실적수량
                    cellStyle: { textAlign: "right" },
                    aggFunc: "sum",
                    minWidth: 100,
                  },
                  {
                    field: wkStDt,
                    headerName:
                      getLanData.length > 0
                        ? getLanData.filter(
                            (f) =>
                              f.lanId === "Col_WkStTime" && f.lanType === "COL"
                          )[0].lanName
                        : "", //시작시간
                    cellStyle: { textAlign: "right" },
                    minWidth: 150,
                  },
                  {
                    field: wkEdDt,
                    headerName:
                      getLanData.length > 0
                        ? getLanData.filter(
                            (f) =>
                              f.lanId === "Col_WkEdTime" && f.lanType === "COL"
                          )[0].lanName
                        : "", //종료시간
                    cellStyle: { textAlign: "right" },
                    minWidth: 150,
                  },
                  {
                    field: processTime,
                    headerName:
                      getLanData.length > 0
                        ? getLanData.filter(
                            (f) =>
                              f.lanId === "Col_WorkingDt" && f.lanType === "COL"
                          )[0].lanName
                        : "", //작업소요시간
                    cellStyle: { textAlign: "right" },
                    minWidth: 130,
                  },
                ],
              });
            }
          }
          setColumnDefs(getProcData);
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      SearchLogic();
    }
  };

  //작업일보 조회
  const SearchLogic = async () => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];
    let getProcData = [];
    let getProcData1 = [];
    const formattedDate = nowDate
      .toLocaleDateString("en-GB", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .split("/")
      .reverse()
      .join("-");
    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);

      await Commons.Axios(
        "get",
        Global.serverUrls.useUrl +
          Global.urls.logic.Manufacture.MM10040.GetWorkOrder,
        {
          startDate: new Date(startDate),
          endDate: new Date(endDate),
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: getLanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else if (data.type === "Error") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: getLanData.filter(
              (f) => f.lanId === "Snack_NullData" && f.lanType === "SNACK"
            )[0].lanName,
          });
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              plantCd: data[i].plantCd,
              woNo: data[i].woNo,
              workDt: data[i].workDt
                ? Commons.DateFormating(data[i].workDt.toString(), 2)
                : "",
              stusCd: data[i].stusCd,
              stusNm: data[i].stusNm,
              itemCd: data[i].itemCd,
              itemNm: data[i].itemNm,
              itemStd: data[i].itemStd1,
              custNm: data[i].custNm,
              plantNm: data[i].plantNm,
              whNm: data[i].whNm,
              soNo: data[i].soNo,
              itemQty: data[i].itemQty,
              delivQty: data[i].delivQty,
              quanQty: data[i].quanQty,
              soDt: data[i].soDt
                ? Commons.DateFormating(data[i].soDt.toString(), 2)
                : "",
              soDueDt: data[i].soDueDt
                ? Commons.DateFormating(data[i].soDueDt.toString(), 2)
                : "",
              processCd1:
                data[i].processCd1 === null ? "1" : data[i].processCd1,
              processCd2:
                data[i].processCd2 === null ? "1" : data[i].processCd2,
              processCd3:
                data[i].processCd3 === null ? "1" : data[i].processCd3,
              processCd4:
                data[i].processCd4 === null ? "1" : data[i].processCd4,
              // processTime1: data[i].wkEdDt1
              //   ? Commons.DateDiff(data[i].wkStDt1, data[i].wkEdDt1).toFixed(4)
              //   : null,
              processTime2: data[i].wkEdDt2
                ? Commons.calculateDateTimeDifference(
                    data[i].wkStDt2,
                    data[i].wkEdDt2
                  )
                : null,
              processTime3: data[i].wkEdDt3
                ? Commons.calculateDateTimeDifference(
                    data[i].wkStDt3,
                    data[i].wkEdDt3
                  )
                : null,
              processTime4: data[i].wkEdDt4
                ? Commons.calculateDateTimeDifference(
                    data[i].wkStDt4,
                    data[i].wkEdDt4
                  )
                : null,
              processTime5: data[i].wkEdDt5
                ? Commons.calculateDateTimeDifference(
                    data[i].wkStDt5,
                    data[i].wkEdDt5
                  )
                : null,
              processTime6: data[i].wkEdDt6
                ? Commons.calculateDateTimeDifference(
                    data[i].wkStDt6,
                    data[i].wkEdDt6
                  )
                : null,
              processTime7: data[i].wkEdDt7
                ? Commons.calculateDateTimeDifference(
                    data[i].wkStDt7,
                    data[i].wkEdDt7
                  )
                : null,
              processTime8: data[i].wkEdDt8
                ? Commons.calculateDateTimeDifference(
                    data[i].wkStDt8,
                    data[i].wkEdDt8
                  )
                : null,
              processTime9: data[i].wkEdDt9
                ? Commons.calculateDateTimeDifference(
                    data[i].wkStDt9,
                    data[i].wkEdDt9
                  )
                : null,
              processTime10: data[i].wkEdDt10
                ? Commons.calculateDateTimeDifference(
                    data[i].wkStDt10,
                    data[i].wkEdDt10
                  )
                : null,
              processTime11: data[i].wkEdDt11
                ? Commons.calculateDateTimeDifference(
                    data[i].wkStDt11,
                    data[i].wkEdDt11
                  )
                : null,
              processTime12: data[i].wkEdDt11
                ? Commons.calculateDateTimeDifference(
                    data[i].wkStDt12,
                    data[i].wkEdDt12
                  )
                : null,
              processTime13: data[i].wkEdDt13
                ? Commons.calculateDateTimeDifference(
                    data[i].wkStDt13,
                    data[i].wkEdDt13
                  )
                : null,
              processTime14: data[i].wkEdDt14
                ? Commons.calculateDateTimeDifference(
                    data[i].wkStDt14,
                    data[i].wkEdDt14
                  )
                : null,
              quanQty: data[i].quanQty,
              // seqQty1: data[i].seqQty1,
              seqQty2: data[i].seqQty2,
              seqQty3: data[i].seqQty3,
              seqQty4: data[i].seqQty4,
              seqQty5: data[i].seqQty5,
              seqQty6: data[i].seqQty6,
              seqQty7: data[i].seqQty7,
              seqQty8: data[i].seqQty8,
              seqQty9: data[i].seqQty9,
              seqQty10: data[i].seqQty10,
              seqQty11: data[i].seqQty11,
              seqQty12: data[i].seqQty12,
              seqQty13: data[i].seqQty13,
              seqQty14: data[i].seqQty14,
              // workQty1: data[i].workQty1,
              workQty2: data[i].workQty2,
              workQty3: data[i].workQty3,
              workQty4: data[i].workQty4,
              workQty5: data[i].workQty5,
              workQty6: data[i].workQty6,
              workQty7: data[i].workQty7,
              workQty8: data[i].workQty8,
              workQty9: data[i].workQty9,
              workQty10: data[i].workQty10,
              workQty11: data[i].workQty11,
              workQty12: data[i].workQty12,
              workQty13: data[i].workQty13,
              workQty14: data[i].workQty14,
              // wkStDt1: data[i].wkStDt1,
              wkStDt2: data[i].wkStDt2
                ? Commons.DateTimeChange(data[i].wkStDt2)
                : "",
              wkStDt3: data[i].wkStDt3
                ? Commons.DateTimeChange(data[i].wkStDt3)
                : "",
              wkStDt4: data[i].wkStDt4
                ? Commons.DateTimeChange(data[i].wkStDt4)
                : "",
              wkStDt5: data[i].wkStDt5
                ? Commons.DateTimeChange(data[i].wkStDt5)
                : "",
              wkStDt6: data[i].wkStDt6
                ? Commons.DateTimeChange(data[i].wkStDt6)
                : "",
              wkStDt7: data[i].wkStDt7
                ? Commons.DateTimeChange(data[i].wkStDt7)
                : "",
              wkStDt8: data[i].wkStDt8
                ? Commons.DateTimeChange(data[i].wkStDt8)
                : "",
              wkStDt9: data[i].wkStDt9
                ? Commons.DateTimeChange(data[i].wkStDt9)
                : "",
              wkStDt10: data[i].wkStDt10
                ? Commons.DateTimeChange(data[i].wkStDt10)
                : "",
              wkStDt11: data[i].wkStDt11
                ? Commons.DateTimeChange(data[i].wkStDt11)
                : "",
              wkStDt12: data[i].wkStDt12
                ? Commons.DateTimeChange(data[i].wkStDt12)
                : "",
              wkStDt13: data[i].wkStDt13
                ? Commons.DateTimeChange(data[i].wkStDt13)
                : "",
              wkStDt14: data[i].wkStDt14
                ? Commons.DateTimeChange(data[i].wkStDt14)
                : "",
              // wkEdDt1: data[i].wkEdDt1,
              wkEdDt2: data[i].wkEdDt2
                ? Commons.DateTimeChange(data[i].wkEdDt2)
                : "",
              wkEdDt3: data[i].wkEdDt3
                ? Commons.DateTimeChange(data[i].wkEdDt3)
                : "",
              wkEdDt4: data[i].wkEdDt4
                ? Commons.DateTimeChange(data[i].wkEdDt4)
                : "",
              wkEdDt5: data[i].wkEdDt5
                ? Commons.DateTimeChange(data[i].wkEdDt5)
                : "",
              wkEdDt6: data[i].wkEdDt6
                ? Commons.DateTimeChange(data[i].wkEdDt6)
                : "",
              wkEdDt7: data[i].wkEdDt7
                ? Commons.DateTimeChange(data[i].wkEdDt7)
                : "",
              wkEdDt8: data[i].wkEdDt8
                ? Commons.DateTimeChange(data[i].wkEdDt8)
                : "",
              wkEdDt9: data[i].wkEdDt9
                ? Commons.DateTimeChange(data[i].wkEdDt9)
                : "",
              wkEdDt10: data[i].wkEdDt10
                ? Commons.DateTimeChange(data[i].wkEdDt10)
                : "",
              wkEdDt11: data[i].wkEdDt11
                ? Commons.DateTimeChange(data[i].wkEdDt11)
                : "",
              wkEdDt12: data[i].wkEdDt12
                ? Commons.DateTimeChange(data[i].wkEdDt12)
                : "",
              wkEdDt13: data[i].wkEdDt13
                ? Commons.DateTimeChange(data[i].wkEdDt13)
                : "",
              wkEdDt14: data[i].wkEdDt14
                ? Commons.DateTimeChange(data[i].wkEdDt14)
                : "",
            });
          }
          setRowData(getRowData);
        }
      });
    } catch (e) {
      if (e.response.status === 401) {
        setSnackbars({
          toggle: true,
          type: "error",
          message: "로그인 정보가 만료되었습니다.",
        });
      } else {
        setSnackbars({
          toggle: true,
          type: "error",
          message: e.message,
        });
      }
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const SearchBomLogic = async (_woNo, _itemCd) => {
    Dialog.ProgressBar(true);
    let getLanData = [];
    let getRowData = [];

    try {
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length > 0) {
          getLanData = result.filter((f) => f.lanType !== "MENU");
        }
      });
      setLanData(getLanData);

      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl +
          Global.urls.logic.Manufacture.MM10040.GetWorkUsed,
        {
          woNo: _woNo,
          itemCd: _itemCd,
        }
      ).then((result) => {
        let data = result.data;
        if (data === "데이터가 없습니다.") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: data,
          });
        } else if (data.type === "Error") {
          setSnackbars({
            toggle: true,
            type: "info",
            message: "데이터가 없습니다.",
          });
        } else {
          for (let i = 0; i < data.length; i++) {
            getRowData.push({
              processCd: data[i].processCd,
              workDt: data[i].workDt
                ? Commons.DateFormating(data[i].workDt.toString(), 2)
                : "",
              seqQty: data[i].seqQty,
              seqFailQty: data[i].seqFailQty,
              seqQtyRate: data[i].seqQtyRate,
              seqFailQtyRate: data[i].seqFailQtyRate,
            });
          }
          setRowData();
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  return (
    <>
      <Mm10040View
        rowData={rowData}
        setRowData={setRowData}
        rowData1={rowData1}
        setRowData1={setRowData1}
        procData={procData}
        setProcData={setProcData}
        columnDefs={columnDefs}
        setColumnDefs={setColumnDefs}
        changedRowData={changedRowData}
        setChangedRowData={setChangedRowData}
        setSelectedRowData={setSelectedRowData}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        nowDate={nowDate}
        setNowDate={setNowDate}
        SearchLogic={SearchLogic}
        SearchBomLogic={SearchBomLogic}
        setStartDate={setStartDate}
        startDate={startDate}
        setEndDate={setEndDate}
        endDate={endDate}
        lanData={lanData}
        selectedRadio={selectedRadio}
        setSelectedRadio={setSelectedRadio}
      />{" "}
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </>
  );
}

export default MM10040;
